import { inject, provide } from 'vue';
import { InsightAxisRetryKey } from '@/components/home/insights/injectionKeys';

export const provideInsightAxisRetry = (retry: () => Promise<void> | void) => {
  provide(InsightAxisRetryKey, retry);
};

// パネルはコンテナ外（Storybook など）でも描画されるため、未提供なら何もしない。
export const useInsightAxisRetry = (): (() => Promise<void> | void) =>
  inject(InsightAxisRetryKey, () => {});
